import { changeStartEndStringTimeZone } from '@/utils';
import { timeZoneCode } from '@/constants/global';
export default class PostHubFormDto {
    workingTime = {
        on: '00:00',
        off: '23:59',
    };
    hubConfiguration = {
        assignedWorkerCatchYn: false,
        sortByCode: 'USER_CHOICE',
        kilometerProductAllYn: false,
        minimumKilometerProduct: 1,
        kilometerProduct: 10,
        shareCallColorType: '0',
        assignedWorkerLockTime: 0,
        orderShowTime: 0,
        option: {
            isDoubleClickPrevention: false,
            isAssignedWorkerCatchHidden: false,
            isAllocatedAfterCancel: false,
            isWorkerSupportAmount: false,
            isDeliveryStatus: false,
            isCustomerMessageService: 'Y',
        },
    };
    workerOneClickBaechaYn = false;
    laterUseYn = false;
    businessNumber = '';
    distanceProduct = 1.3;
    addressFormData;
    masterId = '';
    masterPassword = '';
    name = '';
    addressSiDo = '';
    addressSiGunGu = '';
    addressDong = '';
    addressLi = '';
    addressJibun = '';
    addressRoad = '';
    addressBuildingNumber = '';
    addressBuildingName = '';
    addressDetail = '';
    longitude = '';
    latitude = '';
    useYn = 'Y';
    hubRepresentativePhone = '';
    phone = '';
    fax = '';
    withdrawalBankCode = '';
    withdrawalBankAccount = '';
    withdrawalBankOwner = '';
    businessName = '';
    ceoName = '';
    ceoPhone = '';
    ceoEmail = '';
    businessCondition = '';
    businessType = '';
    constructor(data) {
        Object.assign(this, data);
        const payload = this.convertSubmitDataToPayload(data);
        Object.assign(this, payload);
        delete this.addressFormData;
    }
    get convertWorkingTimeToString() {
        const { on, off } = this.workingTime;
        const formattedWorkingTimeToString = on.replace(':', '') + off.replace(':', '');
        return changeStartEndStringTimeZone(formattedWorkingTimeToString, timeZoneCode.UTC);
    }
    get convertAssignWorkerCatchYnToString() {
        return this.hubConfiguration.assignedWorkerCatchYn ? 'Y' : 'N';
    }
    get convertKilometerProductAllYnToString() {
        return this.hubConfiguration.kilometerProductAllYn ? 'Y' : 'N';
    }
    get convertLaterUseYnToString() {
        return this.laterUseYn ? 'Y' : 'N';
    }
    get convertDistanceProductToFixedPointNotation() {
        return this.distanceProduct.toFixed(1);
    }
    convertSubmitDataToPayload = (data) => {
        const submitDataList = Object.entries(data);
        return submitDataList.reduce((acc, [key, value,]) => {
            if (value === '') {
                return acc;
            }
            if (key === 'addressFormData') {
                Object.entries(value).forEach(([addressDTOKey, addressDTOValue,]) => {
                    const replacedKey = addressDTOKey.replace('_', '');
                    // detail은 수정 시 수정 전에 값이 있다가 수정 후 값이 없을 수 있으므로 빈 문자열이라도 보낸다
                    const regexStringType = 'enclosedRoad|memo';
                    const notIncludeAddressInfoRegex = new RegExp(regexStringType);
                    const isNotInclude = notIncludeAddressInfoRegex.test(replacedKey);
                    if (replacedKey === 'location') {
                        const { longitude, latitude } = addressDTOValue;
                        acc.longitude = longitude;
                        acc.latitude = latitude;
                        return acc;
                    }
                    if (isNotInclude || typeof addressDTOValue !== 'string') {
                        return acc;
                    }
                    const capitalizedKey = replacedKey.charAt(0).toUpperCase() + replacedKey.slice(1);
                    acc[`address${capitalizedKey}`] = addressDTOValue;
                    return acc;
                });
            }
            if (key === 'workingTime') {
                acc[key] = this.convertWorkingTimeToString;
                return acc;
            }
            if (key === 'hubConfiguration') {
                acc.hubConfiguration = {
                    ...value,
                    assignedWorkerCatchYn: this.convertAssignWorkerCatchYnToString,
                    kilometerProductAllYn: this.convertKilometerProductAllYnToString,
                };
                return acc;
            }
            if (key === 'laterUseYn') {
                acc[key] = this.convertLaterUseYnToString;
                return acc;
            }
            if (key === 'distanceProduct') {
                acc[key] = this.convertDistanceProductToFixedPointNotation;
                return acc;
            }
            acc[key] = value;
            return acc;
        }, {
            hubConfiguration: {},
        });
    };
    convertEditBasicInfoSubmitDataToPayload = () => {
        const { name, addressSiDo, addressSiGunGu, addressDong, addressLi, addressJibun, addressRoad, addressBuildingNumber, addressBuildingName, addressDetail, latitude, longitude, phone, hubRepresentativePhone, fax, useYn, workingTime, withdrawalBankCode, withdrawalBankAccount, withdrawalBankOwner, businessNumber, businessName, ceoName, ceoEmail, ceoPhone, businessCondition, businessType, } = this;
        return {
            name,
            addressSiDo,
            addressSiGunGu,
            addressDong,
            addressLi,
            addressJibun,
            addressRoad,
            addressBuildingNumber,
            addressBuildingName,
            addressDetail,
            latitude,
            longitude,
            workingTime,
            phone,
            hubRepresentativePhone,
            fax,
            useYn,
            withdrawalBankCode,
            withdrawalBankAccount,
            withdrawalBankOwner,
            businessNumber,
            businessName,
            ceoName,
            ceoPhone,
            ceoEmail,
            businessCondition,
            businessType,
        };
    };
    convertEditWorkerOperationInfoSubmitDataToPayload = () => {
        const { workerOneClickBaechaYn, hubConfiguration: { assignedWorkerCatchYn, sortByCode, kilometerProductAllYn, minimumKilometerProduct, kilometerProduct, shareCallColorType, assignedWorkerLockTime, orderShowTime, option: { isDoubleClickPrevention, isAssignedWorkerCatchHidden, isAllocatedAfterCancel, }, }, } = this;
        return {
            workerOneClickBaechaYn,
            hubConfiguration: {
                assignedWorkerCatchYn,
                sortByCode,
                kilometerProductAllYn,
                minimumKilometerProduct,
                kilometerProduct,
                shareCallColorType,
                assignedWorkerLockTime,
                orderShowTime,
                option: {
                    isDoubleClickPrevention,
                    isAssignedWorkerCatchHidden,
                    isAllocatedAfterCancel,
                },
            },
        };
    };
    convertEditAdjustmentOperationInfoSubmitDataToPayload = () => {
        const { laterUseYn, distanceProduct, hubConfiguration: { option: { isWorkerSupportAmount, isCustomerMessageService, isDeliveryStatus, }, }, } = this;
        return {
            laterUseYn,
            distanceProduct,
            hubConfiguration: {
                option: {
                    isWorkerSupportAmount,
                    isCustomerMessageService,
                    isDeliveryStatus,
                },
            },
        };
    };
}
